<template>
  <div>
    <Tree :data="permissionList" show-checkbox mutiple @on-check-change="checkChange"></Tree>
  </div>
</template>

<script>
export default {
  name: 'permissionTree',
  props: {
    permissionData: {
      type: Array,
      default: () => {
        return []
      }
    },
    rolePermission: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      permissionList: []
    }
  },
  watch: {
    permissionData(val) {
      this.refreshPermissionList(val)
    },
    rolePermission(val) {
      this.refreshPermissionList(this.permissionData, val)
    }
  },
  methods: {
    refreshPermissionList(permissionData, rolePermission = []) {
      if (permissionData.length === 0) return
      let copyPermissionList = []
      permissionData.forEach(permission => {
        let checked = false
        if (rolePermission.indexOf(permission.name) !== -1) {
          checked = true
        }
        copyPermissionList.push({
          title: permission.displayName,
          name: permission.name,
          checked: checked
        })
      })
      for (let i = permissionData.length - 1; i >= 0; i--) {
        let item = copyPermissionList[i]
        let lastIndex = item.name.lastIndexOf('.')
        if (lastIndex !== -1) {
          let firstName = item.name.slice(0, lastIndex)
          for (let j = 0; j < copyPermissionList.length ;j++) {
            if (copyPermissionList[j].name === firstName) {
              copyPermissionList[j].expand = true
              copyPermissionList[j].children = copyPermissionList[j].children || []
              copyPermissionList[j].children.push(copyPermissionList.splice(i, 1)[0])
              if (copyPermissionList[j].checked) {
                copyPermissionList[j].checked = false
              }
              break
            }
          }
        }
      }
      this.permissionList = copyPermissionList
    },
    checkChange(checkList) {
      let selectPermissions = []
      checkList.forEach(check => {
        let nameArr = check.name.split('.')
        let name = ''
        for (let i = 0; i < nameArr.length; i++) {
          name += `.${nameArr[i]}`
          if (i === 0) {
            name = name.slice(1)
          }
          if (selectPermissions.indexOf(name) === -1) {
            selectPermissions.push(name)
          }
        }
      })
      this.$emit('checkChange', selectPermissions)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
